import React from 'react';
import { Check, Clock, BookOpen, Zap, Award } from 'lucide-react';
import { QUIZ_MODES, getModeConfig, getTimerSettings } from '../../utils/timerManager';
import { playSound } from '../../utils/soundManager';

const QuizModeSelector = ({ 
  currentMode, 
  onSelect, 
  difficulty,
  onClose 
}) => {
  const modes = [QUIZ_MODES.PRACTICE, QUIZ_MODES.TIMED];
  const timerSettings = getTimerSettings(difficulty);

  const handleSelect = (mode) => {
    playSound('click');
    onSelect(mode);
  };

  return (
    <div className="quiz-mode-selector">
      <div className="quiz-mode-header">
        <h3>Choose Quiz Mode</h3>
        <p>Select how you want to play!</p>
      </div>

      <div className="quiz-mode-options">
        {modes.map((mode, index) => {
          const config = getModeConfig(mode);
          const isSelected = currentMode === mode;

          return (
            <div
              key={mode}
              className={`quiz-mode-card hover-lift animate-scaleIn ${
                isSelected ? 'selected' : ''
              }`}
              onClick={() => handleSelect(mode)}
              style={{
                animationDelay: `${index * 0.1}s`,
                borderColor: isSelected ? config.color : 'var(--border-color)'
              }}
            >
              <div className="mode-icon" style={{ color: config.color }}>
                <span className="mode-emoji">{config.icon}</span>
              </div>

              <h4 style={{ color: config.color }}>{config.name}</h4>
              <p className="mode-description">{config.description}</p>

              <div className="mode-features">
                {mode === QUIZ_MODES.PRACTICE ? (
                  <>
                    <div className="mode-feature">
                      <BookOpen size={16} />
                      <span>No time limit</span>
                    </div>
                    <div className="mode-feature">
                      <Check size={16} />
                      <span>Learn at your pace</span>
                    </div>
                    <div className="mode-feature">
                      <Award size={16} />
                      <span>Focus on accuracy</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mode-feature">
                      <Clock size={16} />
                      <span>{timerSettings.timePerQuestion}s per question</span>
                    </div>
                    <div className="mode-feature">
                      <Zap size={16} />
                      <span>+{timerSettings.bonusPoints} bonus points</span>
                    </div>
                    <div className="mode-feature">
                      <Award size={16} />
                      <span>Speed challenge</span>
                    </div>
                  </>
                )}
              </div>

              {isSelected && (
                <div className="mode-selected-indicator" style={{ background: config.color }}>
                  <Check size={20} color="white" />
                  Selected
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="quiz-mode-info">
        <p>💡 You can change the mode anytime from settings</p>
      </div>
    </div>
  );
};

export default QuizModeSelector;
